module.exports = __webpack_public_path__ + "assets/d0ae804cbcf1a212d1a29b2fac1aace1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/2.png
// module id = 380
// module chunks = 1